import { render, staticRenderFns } from "./SwipeDataReport.vue?vue&type=template&id=b869b0e8"
import script from "./SwipeDataReport.vue?vue&type=script&lang=js"
export * from "./SwipeDataReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports